import React from "react";
import "animate.css";

function Struc() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex flex-col md:grid grid-cols-9 mx-auto text-blue-50">
        {/* Our Short History */}
        <div className="flex flex-row-reverse md:contents">
          <div className="bg-blue-400 col-start-1 col-end-5 p-6 rounded-xl my-4 ml-auto shadow-md animate__animated animate__bounceInDown animate__delay-3s">
            <h3 className="font-semibold text-lg mb-2">Our Short History</h3>
            <p className="leading-relaxed text-justify">
              The Meklit Humanitarian Association non-profit was established on
              October 11, 2022 G.C. Some concerned members of the church came
              together voluntarily to create a project with the goal of
              "boosting the economic capacity of Orthodox youths."
            </p>
          </div>
          <div className="col-start-5 col-end-6 md:mx-auto relative flex justify-center">
            <div className="h-full w-1 bg-blue-400"></div>
            <div className="w-6 h-6 absolute top-1/2 transform -translate-y-1/2 rounded-full bg-blue-400 shadow animate__animated animate__heartBeat animate__infinite"></div>
          </div>
        </div>

        {/* Our Mission */}
        <div className="flex md:contents">
          <div className="col-start-5 col-end-6 md:mx-auto relative flex justify-center">
            <div className="h-full w-1 bg-blue-400"></div>
            <div className="w-6 h-6 absolute top-1/2 transform -translate-y-1/2 rounded-full bg-blue-400 shadow animate__animated animate__heartBeat animate__infinite"></div>
          </div>
          <div className="bg-blue-400 col-start-6 col-end-10 p-6 rounded-xl my-4 mr-auto shadow-md animate__animated animate__bounceInRight animate__delay-3s">
            <h3 className="font-semibold text-lg mb-2">Our Mission</h3>
            <p className="leading-relaxed text-justify">
              Meklit Humanitarian Association provides a variety of programs to
              assist orthodox youth grow in their profession and career, as well
              as establish a robust digital business network.
            </p>
          </div>
        </div>

        {/* Our Vision */}
        <div className="flex flex-row-reverse md:contents">
          <div className="bg-blue-400 col-start-1 col-end-5 p-6 rounded-xl my-4 ml-auto shadow-md animate__animated animate__fadeInTopRight animate__delay-2s">
            <h3 className="font-semibold text-lg mb-2">Our Vision</h3>
            <p className="leading-relaxed text-justify">
              We envision that Meklit Humanitarian Association will support the
              development of financially stable Orthodox youth who can actively
              engage in the nation's economic, political, and social concerns.
            </p>
          </div>
          <div className="col-start-5 col-end-6 md:mx-auto relative flex justify-center">
            <div className="h-full w-1 bg-blue-400"></div>
            <div className="w-6 h-6 absolute top-1/2 transform -translate-y-1/2 rounded-full bg-blue-400 shadow animate__animated animate__heartBeat animate__infinite"></div>
          </div>
        </div>

        {/* Values and Principles */}
        <div className="flex md:contents">
          <div className="col-start-5 col-end-6 md:mx-auto relative flex justify-center">
            <div className="h-full w-1 bg-blue-400"></div>
            <div className="w-6 h-6 absolute top-1/2 transform -translate-y-1/2 rounded-full bg-blue-400 shadow animate__animated animate__heartBeat animate__infinite"></div>
          </div>
          <div className="bg-blue-400 col-start-6 col-end-10 p-6 rounded-xl my-4 mr-auto shadow-md">
            <h3 className="font-semibold text-lg mb-2">
              Values and Principles
            </h3>
            <p className="leading-relaxed text-justify">
              • Spiritual service <br /> • Strong work culture <br /> •
              Brotherhood
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Struc;
